//import { gsap } from 'gsap';
//import { ScrollTrigger } from 'gsap/ScrollTrigger';



export default {
  init() {
    // JavaScript to be fired on the home page

    //gsap.registerPlugin(ScrollTrigger);


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    var autoPlayVideo = document.getElementById('hero-video');
    autoPlayVideo.oncanplaythrough = function() {
        autoPlayVideo.muted = true;
        autoPlayVideo.play();
        autoPlayVideo.pause();
        autoPlayVideo.play();
    }

    window.addEventListener('load', function(){
      var newVideo = document.getElementById('hero-video');
      newVideo.addEventListener('ended', function() {
          this.currentTime = 0;
          this.play();
      }, false);
  
      newVideo.play();
    });


    //delay scroll ltrigger
    setTimeout(function() { 

   }, 2000);




  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js